import {
  CellStyleModule,
  CheckboxEditorModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnAutoSizeModule,
  CustomEditorModule,
  DateEditorModule,
  DateFilterModule,
  EventApiModule,
  LargeTextEditorModule,
  ModuleRegistry,
  NumberEditorModule,
  PaginationModule,
  QuickFilterModule,
  RowApiModule,
  RowSelectionModule,
  RowStyleModule,
  SelectEditorModule,
  TextEditorModule,
  ValidationModule,
  type _ModuleWithoutApi
} from 'ag-grid-community';
import {
  LicenseManager,
  RichSelectModule,
  RowGroupingModule,
  SetFilterModule,
  TreeDataModule
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  TextEditorModule,
  NumberEditorModule,
  DateEditorModule,
  CheckboxEditorModule,
  LargeTextEditorModule,
  SelectEditorModule,
  RichSelectModule,
  CustomEditorModule
]);

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-080992}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{BEST_PRACTICE_CONSULTING}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{26_September_2026}____[v3]_[01]_MTc5MDM3NzIwMDAwMA==6b2f3bd4ffe34a1a37b656a7db0df8c8'
);

const modulesToRegister: _ModuleWithoutApi[] = [
  ClientSideRowModelModule,
  TreeDataModule,
  RowGroupingModule,
  ValidationModule,
  DateFilterModule,
  SetFilterModule,
  RowStyleModule,
  RowSelectionModule,
  CellStyleModule
];
if (import.meta.env.DEV) {
  modulesToRegister.push(ValidationModule);
}

ModuleRegistry.registerModules([
  ...modulesToRegister,

  PaginationModule,

  ColumnAutoSizeModule,

  RowApiModule,
  ClientSideRowModelApiModule,
  EventApiModule,
  QuickFilterModule
]);
